import { useEffect, useState } from 'react';
import { get } from '../../../../../../services/request';
import { InitInputValue } from '../aux';

interface Assistance {
  id: string;
  nome: string;
  idTipoSeguro: number;
  padrao: boolean;
}
export const useAssistances = (estateId: string, propertyUseType?: number) => {
  const [assistances, setAssistances] = useState(InitInputValue);
  const [loading, setLoading] = useState(false);
  const [defaultAssistanceId, setDefaultAssistanceId] = useState<number | null>(null);

  useEffect(() => {
    if (!estateId || !propertyUseType) return;

    const fetchAssistances = async () => {
      setLoading(true);
      try {
        const data = await get(
          `/fire-insurance-quotations/segimob/domains/assistances?estateId=${estateId}&occupationId=${propertyUseType}`
        );
        setAssistances(
          data.map((assistance: Assistance) => ({
            key: assistance.id,
            text: assistance.nome,
            value: assistance.id
          }))
        );

        const defaultAssistance = data.find(
          (assistance: Assistance) => assistance.padrao
        );
        if (defaultAssistance) {
          setDefaultAssistanceId(defaultAssistance.id);
        } else {
          setDefaultAssistanceId(null);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAssistances();
  }, [estateId, propertyUseType]);

  return { assistances, loading, defaultAssistanceId };
};
